import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ResponseMessage } from '../model/FormsEntity/response';

@Injectable({
  providedIn: 'root'
})

export class LeaseLicenseService{
  getReocrd(applicationNo: string) {
    throw new Error('Method not implemented.');
  }
    private leaseLicense: string;
    private leaseLicenseWF: string;
    private documentUrl: string;
  constructor(private http:HttpClient) { 
    this.leaseLicense = environment.baseUrl + 'leaseAndLicenseFee/';
    this.leaseLicenseWF = environment.wflowUrl + 'leaseAndLicense/workflow/';
    this.documentUrl = environment.baseUrl + 'fileUtils/getDownloadedFile';
    
  }
  
  public saveLeaseAndLicenseFeeDetails(data){
    return this.http.post<ResponseMessage>(this.leaseLicense +'saveLeaseAndLicenseFeeDetails',data);
  }
  public updateDuesByDeptUser(data){
    return this.http.post<ResponseMessage>(this.leaseLicense +'updateDuesByDeptUser',data);
  }
  //in use
  public getLeaseAndLicenseFeeDetails(applicantId){
    return this.http.get<any>(this.leaseLicense +'getLeaseAndLicenseFeeDetails/'+applicantId);
  }
  //in use
  public getLeaseLicenseDetailsWFList(applicantId,rolename,applicantionfor){
   
    const params = new HttpParams()
    .set('id', applicantId)
    .set('roleName', rolename)
    .set('applicationFor', applicantionfor);

    return this.http.get<any>(this.leaseLicense +'getLeaseLicenseDetailsWFList/',{params});
  }
  
  public getLeaseAndLicenseFeeList(applicantId){
    return this.http.get<any>(this.leaseLicense +'getLeaseAndLicenseFeeList/'+applicantId);
  }

  public getLeaseAndLicenseFeeDetailsByFileNo(fileNo){
    const params = new HttpParams()
            .set('fileNo', fileNo)
    return this.http.get<any>(this.leaseLicense +'getLeaseAndLicenseFeeDetailsByFileNo',{params});
  }
  public getLeaseAndLicenseFeeDetailsList(applicationId){
    return this.http.get<any>(this.leaseLicense +'getLeaseAndLicenseFeeList/'+applicationId);
  }
  public getWorkFlowHistory(applicationNo) {

    return this.http.get<any>(this.leaseLicense + 'getWorkFlowHistory/' + applicationNo);
}

  public leaseAndLicenseProcess(data){
    return this.http.post<any>(this.leaseLicenseWF +'leaseAndLicenseProcess',data);
  }
  public getSaveLeaseAndLicenseApplicantKyc(applicationNo){
    return this.http.get<any>(this.leaseLicense +'getSaveLeaseAndLicenseApplicantKyc/'+applicationNo);
  }
  public saveLeaseAndLicenseApplicantKyc(data){
    return this.http.post<any>(this.leaseLicense +'saveLeaseAndLicenseApplicantKyc',data);
  }

  public getApplicantKycDetailsWFList(id,roleName,applicantionfor){
    const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName)
      .set('applicationType', applicantionfor);;
    return this.http.get<any>(this.leaseLicense +'getApplicantKycDetailsWFList',{params});
  }
  public deleteOnChangeSelectionIndFirm(appId){
    return this.http.get<any>(this.leaseLicense +'deleteOnChangeSelectionIndFirm/'+appId);
}
public getUsersForWF(model) {
  return this.http.post<any>(this.leaseLicense + 'getUsersForWF', model);
}

public submitDataToWorkFlow(data){
  return this.http.post<any>(this.leaseLicense +'submitDataToWorkFlow',data);
}
public getLeaseLicensePaymentByFileNo(fileno){
  const params = new HttpParams()
    .set('fileNo', fileno);
  return this.http.get<any>(this.leaseLicense +'getLeaseLicensePaymentByFileNo',{params});
}

public saveLeaseAndLicensePaymentDetailsByApp(model) {
  return this.http.post<any>(this.leaseLicense + 'saveLeaseAndLicensePaymentDetailsByApp', model);
}
public getLeaseLicensePaymentByFileNoForDept(fileno){
  const params = new HttpParams()
    .set('fileNo', fileno);
  return this.http.get<any>(this.leaseLicense +'getLeaseLicensePaymentByFileNoForDept',{params});
}

public leaseAndLicenseAccountsActivity(applicantPaymentId,userId){
  return this.http.get<any>(this.leaseLicense +'leaseAndLicenseAccountsActivity/'+applicantPaymentId+'/'+userId);
}

public getLeaseLicensePaymentHistoryByFileNo(fileno){
  const params = new HttpParams()
    .set('fileNo', fileno);
  return this.http.get<any>(this.leaseLicense +'getLeaseLicensePaymentHistoryByFileNo',{params});
}

public uploadChallanDocumnetByApplicant(model) {
  return this.http.post<any>(this.leaseLicense + 'uploadChallanDocumnetByApplicant', model);
}
public generateImage(fileName) {
  const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
     
  };
  return this.http.post<any>(this.documentUrl , fileName, httpOptions);
}

public fileNoCheck(model) {
  return this.http.post<any>(this.leaseLicense + 'fileNoCheck', model);
}
public getpayementencry(){
  return this.http.get<any>(environment.baseUrl + 'makePayment/' +'makePay');
}

public makePaymentmaharastra(model) {
  return this.http.post<any>(environment.baseUrl+'payment/maharastra/makePayment', model);
}

public makePaymentaxis(model) {
  return this.http.post<any>(environment.baseUrl+'payment/axis/makePayment', model);
}

public leaseAndLicenseProcessKyc(model) {
  return this.http.post<any>( this.leaseLicenseWF+'leaseAndLicenseProcessKyc', model);
}

public getListLeaseLicenseFilesForPayByMobNo(mobNo){
  // const params = new HttpParams()
  //         .set('monNo', mobno)
  return this.http.get<any>(this.leaseLicense +'getListLeaseLicenseFilesForPayByMobNo'+'/'+mobNo);
}

// print form
public getLeaseAndLicenseFeeDetailsByFileNoJaspher(fileNo){
  const params = new HttpParams()
          .set('fileNo', fileNo)
  return this.http.get<any>(this.leaseLicense +'getLeaseAndLicenseFeeDetailsByFileNoJaspher',{params,responseType: 'arraybuffer' as 'json'});
}

public getApplicantPayVarificationWFList(id,roleName,applicantionfor){
  const params = new HttpParams()
    .set('id', id)
    .set('roleName', roleName)
    .set('applicationType', applicantionfor);;
  return this.http.get<any>(this.leaseLicense +'getApplicantPayVarificationWFList',{params});
}
public submitDataToWFNewPayVarification(data){
  return this.http.post<any>(this.leaseLicense +'submitDataToWFNewPayVarification',data);
}
public misReport(propertyvalue) {
  return this.http.get<any>(this.leaseLicense + 'misReportByApplicationType/'+propertyvalue);
}
public leaseLicensemisReport() {
  return this.http.get<any>(this.leaseLicense + 'misReportByApplicationType');
}
public getPropertyList(){
  return this.http.get<any>(this.leaseLicense + 'getPropertyList');
}

public misRep(b :any) {
  debugger
  return this.http.post<any>(this.leaseLicense + 'misRep',b);
}
public getAllRecordsByAppNo(applicationNo: any){
  return this.http.get<any>(this.leaseLicense + 'getPropertyDetails/'+applicationNo);
}

public bhommiData(fileNo) {
  const params = new HttpParams().set('fileNo', fileNo);
  return this.http.get<any>(this.leaseLicense + 'bhommiData', { params });
}
}